import React from "react";
import { Table } from "antd";
import CircleIIcon from "../../../assets/circle_i.svg";
import { removeAccountPrefixFromLabels,getMinimum,getMaxAlert } from "../../../../src/global/utility/Utils";
import ATSToolTip from "../../../global/components/ATSToolTip";
import { getScheduleSummary } from "../../../global/utility/scheduleTimeUtils";

function ShipmentCloneAttributes({attributes}) {
  let tableData = [];
  {
    attributes?.map((item, index) => {
      tableData.push({
        name: `${item?.name} (${item?.unit})`,
        minAlert: getMinimum(item?.name,item?.min),
        maxAlert: getMaxAlert(item),
        alertType: item?.alertType !== null ? item.alertType.charAt(0).toUpperCase() + item.alertType.slice(1) : "None",
        alertGroup: Array.isArray(item?.alertGroup) && item.alertGroup.length > 0
          ? removeAccountPrefixFromLabels(item.alertGroup)?.join(", ")
          : (item?.alertGroup ?? "").toString().trim().length > 0
            ? removeAccountPrefixFromLabels([item.alertGroup])?.join(", ")
            : "None",
        alert: item?.alert ? item?.alert?.charAt(0)?.toUpperCase() + item?.alert?.slice(1)?.toLowerCase() : "Platform alert",
        schedule: getScheduleSummary(item?.customTimeFrame),
      })
    })
  }
const columns = [
  {
  title: (
      <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
        Attribute
      </span>
    ),
    dataIndex: "name",
    key: "name",
    width: 15,
    render: (text) => {
      return (
      <div className="d-flex flex-row justify-content-start align-items-center">
      <div>{text}</div>
    </div>
    )
    },
  },
  {
      title: (
        <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
          Alert 
          <ATSToolTip text="Alert trigger based on">
            <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
        </span>
      ),
      dataIndex: "alert",
      key: "alert",
      width: 15,
    },
  {
  title: (<span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
          Min
          <ATSToolTip text="Minimum value">
            <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
        </span>),
    dataIndex: "minAlert",
    key: "minAlert",
    width: 10,
    render: (text) => {
      return   <div style={{ padding: '8px 12px' }}>{text}</div>;
    },
  },
  {
  title: ( <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
          Max
          <ATSToolTip text="Maximum value">
            <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
        </span>),
    dataIndex: "maxAlert",
   // className: "maxAlert",
  width: 10,
   // render: (text) => <span>{text}</span>,
    key: "maxAlert",
  },
  {
  title: ( <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
          Alert Type
          <ATSToolTip text="Severity level of the alarm">
            <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
        </span>),
    dataIndex: "alertType",
    key: "alertType",
    width: 165,
  //  render: (text, record) => <span>{text}</span>,
  },
  {
    title: (<span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
            Alert Group
            <ATSToolTip text="Alert groups to be notified of the alarm">
              <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
            </ATSToolTip>
          </span>),
      dataIndex: "alertGroup",
      key: "alertGroup",
    width: 165,
    //  render: (text, record) => <span>{text}</span>,
    },
  {
    title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>Schedule</span>),
    dataIndex: "schedule",
    key: "schedule",
  },
]
  return (
    <>
      <div
        className="font-face-vzw shipment-sub-text-color py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171"
        }}
      >
        Attribute
      </div>
      <Table 
       columns={columns}
       dataSource={tableData}
       pagination={false} />
    </>
  );
}

export default ShipmentCloneAttributes;
